import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-custom mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-header align-items-center border-0 mt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-dark fs-3" }, "My Agents"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-2 fw-bold fs-6" }, "More than 400+ new members")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table table-borderless align-middle mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-70px" })
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-55px me-2 mt-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "symbol-label align-items-end" }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "icon",
        src: "media/svg/avatars/001-boy.svg",
        class: "mh-40px"
      })
    ])
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary fs-6"
  }, "Brad Simmons"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block mt-1" }, "Movie Creator")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-icon btn-twitter btn-sm me-3"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook-f" })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-icon btn-facebook btn-sm"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-twitter" })
  ])
], -1)
const _hoisted_14 = { class: "text-end pe-0" }
const _hoisted_15 = {
  href: "#",
  class: "btn btn-icon btn-bg-light btn-active-primary btn-sm"
}
const _hoisted_16 = { class: "svg-icon svg-icon-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-55px me-2 mt-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "symbol-label align-items-end" }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "icon",
        src: "media/svg/avatars/018-girl-9.svg",
        class: "mh-40px"
      })
    ])
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary fs-6"
  }, "Jessie Clarcson"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block mt-1" }, "HTML, CSS Coding")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { class: "text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-icon btn-twitter btn-sm me-3"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook-f" })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-icon btn-facebook btn-sm"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-twitter" })
  ])
], -1)
const _hoisted_20 = { class: "text-end pe-0" }
const _hoisted_21 = {
  href: "#",
  class: "btn btn-icon btn-bg-light btn-active-primary btn-sm"
}
const _hoisted_22 = { class: "svg-icon svg-icon-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-55px me-2 mt-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "symbol-label align-items-end" }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "icon",
        src: "media/svg/avatars/047-girl-25.svg",
        class: "mh-40px"
      })
    ])
  ])
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary fs-6"
  }, "Lebron Wayde"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block mt-1" }, "ReactJS Developer")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-icon btn-twitter btn-sm me-3"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook-f" })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-icon btn-facebook btn-sm"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-twitter" })
  ])
], -1)
const _hoisted_26 = { class: "text-end pe-0" }
const _hoisted_27 = {
  href: "#",
  class: "btn btn-icon btn-bg-light btn-active-primary btn-sm"
}
const _hoisted_28 = { class: "svg-icon svg-icon-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-55px me-2 mt-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "symbol-label align-items-end" }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "icon",
        src: "media/svg/avatars/043-boy-18.svg",
        class: "mh-40px"
      })
    ])
  ])
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "text-dark fw-bolder text-hover-primary fs-6"
  }, "Kevin Leonard"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block mt-1" }, "Amazing Templates")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-icon btn-twitter btn-sm me-3"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook-f" })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-icon btn-facebook btn-sm"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-twitter" })
  ])
], -1)
const _hoisted_32 = { class: "text-end pe-0" }
const _hoisted_33 = {
  href: "#",
  class: "btn btn-icon btn-bg-light btn-active-primary btn-sm"
}
const _hoisted_34 = { class: "svg-icon svg-icon-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown3)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("td", _hoisted_14, [
                _createElementVNode("a", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _createElementVNode("td", _hoisted_20, [
                _createElementVNode("a", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_23,
              _hoisted_24,
              _hoisted_25,
              _createElementVNode("td", _hoisted_26, [
                _createElementVNode("a", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_29,
              _hoisted_30,
              _hoisted_31,
              _createElementVNode("td", _hoisted_32, [
                _createElementVNode("a", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}